import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { PaidBadgeTextContainer } from './StyledComponents';
import { getBadgeFontSize } from '../helpers';

type Props = {
  docWidth: number;
};

const PaidBadge: React.FC<Props> = ({ docWidth }) => {
  return (
    <PaidBadgeTextContainer fontSize={getBadgeFontSize(docWidth)}>
      <FormattedMessage id="documents.item.badge.paid" defaultMessage="Paid" />
    </PaidBadgeTextContainer>
  );
};

export default memo(PaidBadge);
